<template>
  <div>
    <el-pagination
      prev-text="&lt;"
      next-text="&gt;"
      :total="total"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OffsetPaginator',
  props: {
    offset: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      pageSize: 'setting/pageSize',
      pageSizes: 'setting/pageSizes',
    }),
  },
  methods: {
    ...mapActions({
      setPageSize: 'setting/setPageSize',
    }),
    handleSizeChange (size) {
      this.setPageSize(size)
      this.$emit('size-change')
    },
    handleCurrentChange (current) {
      let offset = this.pageSize * (current - 1)
      this.$emit('offset-change', offset)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/parts/OffsetPaginator.vue